export default function Credits(){
	return <div className='credits' html>
		<p>Purely for educational purposes only.</p>
		<p>
			Music is... you know what is... <a href="hhttps://open.spotify.com/track/4w1lzcaoZ1IC2K5TwjalRP?si=7914bd3650434d09" target="_blank">A Thousand Miles by Vanessa Carlton</a>. Duh.
		</p>
		<p>
			Burger Model by the talented dude whom I have inherited the wisdom to create... whatever this is <a href="https://bruno-simon.com/" target="_blank">Bruno Simon</a>
		</p>
		<p>
			Shrek Model by <a href="https://sketchfab.com/3d-models/shrek-walk-cycle-cd5a1e1cd7dd4effa3df11bcaea915f4" target="_blank">This guy... idk his name</a>
		</p>
		<p>
			Piano model by Me biiieeeeaaach. Don't touch it I have plans for it
		</p>
	</div>
}